import { render, staticRenderFns } from "./WorkflowBack.vue?vue&type=template&id=62155057"
import script from "./WorkflowBack.vue?vue&type=script&lang=js"
export * from "./WorkflowBack.vue?vue&type=script&lang=js"
import style0 from "./WorkflowBack.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports